module.exports = __webpack_public_path__ + "resources/img/img_cloud_moa3_m.cc32d91cd64f003d5156f797388643aa.png";